<script context="module" lang="ts">
    export interface SuggestionItem {
        index: number;
        items: Array<{ link?: any; name: string }>;
        value: any;
        type: string;
        text: string;
    }
</script>

<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import { slide } from "svelte/transition";

    export let suggestionItem: SuggestionItem;
    
    const dispatch = createEventDispatcher();

    let cmdSymbol = navigator.platform.includes('Mac') ? '⌘' : 'CTRL';

    $: displayValue = suggestionItem.items.map(item => item.name).join(', ');
</script>

<div class="suggestion group" in:slide on:click={() => dispatch("apply", suggestionItem)}>
    <span>{suggestionItem.text} <b>{displayValue}</b></span>
    <div class="suggestion__shortcut">
        <div class="suggestion__shortcut-key">{cmdSymbol}</div>
        <div class="suggestion__shortcut-key">{suggestionItem.index}</div>
        
        <div class="suggestion__shortcut-button">
            Apply
        </div>
    </div>
</div>

<style>
    .suggestion {
        @apply bg-black items-center rounded-lg rounded-bl-none text-white p-2 text-xs flex gap-1 cursor-pointer hover:bg-gray-700;
    }

    .suggestion__shortcut {
        @apply ml-auto min-w-min flex gap-1 items-center;
    }

    .suggestion__shortcut-key {
        @apply bg-gray-500 text-black uppercase text-2xs px-0.5 min-w-2.5 text-center rounded-sm font-bold hidden sm:block group-hover:hidden;
    }

    .suggestion__shortcut-button {
        @apply bg-gray-500 sm:bg-white text-black uppercase text-2xs px-0.5 min-w-2.5 text-center rounded-sm font-bold block sm:hidden group-hover:block;
    }
</style> 